import {
  FormSlug,
  ImplementationGuideForm,
  ResponseFormat,
} from "@/components/ImplementationGuide/types";
import { FieldName } from "@/components/ImplementationGuide/types/FieldName.enum";

const measuringSuccessForm: ImplementationGuideForm = {
  title: "Measuring success",
  subtitle:
    "Understand your data reports and learn about how to best continue supporting success.",
  slug: FormSlug.MeasuringSuccess,
  form_image: "/images/implementation-guide/Measuring_Success.svg",
  form_index: 5,
  form_description: {
    content:
      "We will better define the desired scope of your Newsela implementation and provide you with resources to monitor your progress.",
    recommendation: "",
  },
  questions: [
    {
      question_index: 1,
      question_text:
        "Are there any grade ranges or subject areas that you see as priority groups for accessing Newsela this year?",
      sub_prompt: null,
      response_format: ResponseFormat.group_of_pop_out_menus,
      is_response_read_only: false,
      field_name: null, // TODO: Should we put field_name in response_fields to capture the distinct field names for each input?
    },
    {
      question_index: 2,
      question_text:
        "For your first semester we recommend reviewing usage to understand engagement with Newsela at your district.",
      sub_prompt:
        "After seeing the usage reporting Newsela can provide you, do you have confidence that you can monitor your implementation of Newsela for success?",
      response_format: ResponseFormat.level_of_confidence,
      is_response_read_only: false,
      field_name: FieldName.Reporting_Monitoring_Confidence,
      response_fields: {
        textarea_title: "Notes",
        textarea_placeholder: "",
        textarea_field_name: FieldName.Reporting_Monitoring_Notes,
      },
    },
  ],
  resources: [
    {
      resource_name: "Usage Report Overview",
      resource_link: "https://support.newsela.com/article/usage-report/",
      todo_item: "Reviewed Usage Report",
      alternative_link: "http://newsela.com/reports/admin/usage-report",
      alternative_link_text: "Try Usage Report",
    },
  ],
};

export default measuringSuccessForm;
